import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/logo.png';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    // Handle blog posts under /blog/ path
    if (path === '/blogs' && location.pathname.startsWith('/blog/')) {
      return true;
    }
    return location.pathname === path;
  };

  const navigationItems = [
    { path: '/', label: 'Home' },
    { path: '/over-ons', label: 'Over ons' },
    { path: '/diensten', label: 'Diensten' },
    { path: '/blogs', label: 'Blogs' },
  ];

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="main-nav">
      <Link to="/" className="logo-container" onClick={closeMenu}>
        <div className="logo">
          <img src={logo} alt="Core Vision Logo" className="logo-mark" />
        </div>
        <div className="logo-text">
          <h1>Core Vision Consultancy</h1>
          <p>Interim Analysis</p>
        </div>
      </Link>
      
      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn md:hidden"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? (
          <X size={24} />
        ) : (
          <Menu size={24} />
        )}
      </button>

      {/* Desktop Navigation */}
      <ul className={`nav-links ${isMenuOpen ? 'show-mobile-menu' : ''}`}>
        {navigationItems.map(({ path, label }) => (
          <li key={path}>
            <Link
              to={path}
              className={`nav-link ${isActive(path) ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {label}
              {isActive(path) && <span className="nav-indicator" />}
            </Link>
          </li>
        ))}
        <li>
          <Link 
            to="/contact" 
            className={`contact-btn ${isActive('/contact') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;